// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".skill-list{margin-bottom:-7.5px;margin-top:3px}.skill-list .btn{margin-right:7.5px;margin-bottom:7.5px;white-space:initial;max-width:100%}\n", ""]);
// Exports
module.exports = exports;
